import { StubPage } from "./StubPage.tsx";

export function NotFoundPage() {
  return <StubPage title="Страница не найдена" backLabel="На главную" />;
}
